export const IMG_ACCEPT = [".avif", ".bmp", ".gif", ".heic", ".heif", ".jpg", ".jpeg", ".png"]

// export const COLOR_OPTIONS = ["#152C73", "#1891F6", "#61b549", "#bed32e", "#e9a52b", "#f6d009", "#eb5623", "#f18c1e", "#FAF0DF", "#F8D7B5", "#617080", "#BAC0D0",]
// export const COLOR_OPTIONS = ["#1891f6", "#152C73", "#1baf2c", "#ffc400", "#002eff", "#f78f06", "#d2afff", "#008043", "#bf9f76", "#b13060", "#ffeedd", "#ddeeff"]
export const COLOR_OPTIONS = ["#009CFF", "#152C73", "#1baf2d", "#ffc400", "#002EFF", "#0566fa", "#f78f06", "#d2afff", "#008043", "#bf9f76", "#b13060", "#3c7530", "#4d4d4d"]
export const LINE_STYLE = { width: 3, shadowColor: "rgba(0,0,0,0.4)", shadowBlur: 10, shadowOffsetY: 10 }
export const BAR_STYLE = [
  1,
  1,
  0,
  0,
  [
    { offset: 0, color: "#1891f6" },
    { offset: 0.5, color: "#1891f6" },
    { offset: 1, color: "#83bff6" }
    // { offset: 0, color: "#6581ff" },
    // { offset: 0.5, color: "#6581ff" },
    // { offset: 1, color: "#99abff" }
  ]
]

export const CHART_OPTIONS = [
  { key: "All", value: 3 },
  { key: "Values", value: 1, data: "amountTotal", unit: "($)", type: "line", itemStyle: { color: "#152C73" }, lineStyle: { ...LINE_STYLE, color: "#152C73" } },
  { key: "Count", value: 2, data: "countTotal", unit: "(#)", type: "bar", itemStyle: { color: "#009CFF" } }
  // { key: "Values", value: 1, data: "amountTotal", unit: "($)", type: "line", itemStyle: { color: "#002eff" }, lineStyle: { ...LINE_STYLE, color: "#002eff" } },
  // { key: "Projects", value: 2, data: "countTotal", unit: "(#)", type: "bar", itemStyle: { color: "#99abff" } }
]

export const ORDER_OPTIONS = [
  { key: "TotalPipeline", value: 1 },
  { key: "ActualOrder", value: 2 },
  { key: "ExpectedOrder", value: 3 }
]

export const LANG_OPTIONS = [
  { name: "English", value: "en" },
  { name: "简体中文", value: "zh" },
  { name: "Español", value: "es" },
  { name: "Deutsch", value: "de" },
  { name: "Français", value: "fr" }
]

export const MONTH_OPTIONS = [
  { key: "Jan", value: 1 },
  { key: "Feb", value: 2 },
  { key: "Mar", value: 3 },
  { key: "Apr", value: 4 },
  { key: "May", value: 5 },
  { key: "Jun", value: 6 },
  { key: "Jul", value: 7 },
  { key: "Aug", value: 8 },
  { key: "Sep", value: 9 },
  { key: "Oct", value: 10 },
  { key: "Nov", value: 11 },
  { key: "Dec", value: 12 }
]

export const TEMPE_DIFF_CONVERT_MAP = ["workingTowerTemp", "ctApproachTemp"]
export const TEMPERATURE_CONVERT_MAP = [
  "temp",
  "temperature",
  "hotWaterTemp",
  "zeroHeatTemp",
  "coldestTemp",
  "designWaterTemp",
  "actualWaterTemp",
  "designRatedTemp",
  "designChilledWaterTemp",
  "workingChilledWaterTemp",
  // "workingTowerTemp",
  "minDry",
  "maxDry",
  "avgDry",
  "minWet",
  "maxWet",
  "avgWet",
  "maxCWS",
  "avgCWS",
  "minWater",
  "maxWater",
  "peakWater",
  "offPeakWater",
  "chilledWaterSupplyTemp",
  "outdoorAirTemp",
  "chwTemp",
  "cwTemp",
  "avgTemp",
  "minCWSTemp",
  "designCHWSTemp",
  "designCWSTemp",
  "defCHWSTemp",
  "defCWSTemp",
  "actualCHWSTemp",
  "requiredSHTemp",
  "maxHeatingOAT",
  "desiredHWTemp",
  "coldestWaterTemp",
  "actualHWSTemp",
  "minEWSTemp",
  "designHWSTemp",
  "designEWSTemp",
  "hwsTemp",
  "ewsTemp",
  "hwsDef",
  "ewsDef"
]

export const TEMP_OPTIONS = [
  { name: "℃", value: 1, unit: "degC" },
  { name: "℉", value: 2, unit: "degF" }
]

export const CAPACITY_UNITS = [
  { value: 1, unit: "RT", load: "RTh", efficiency: "kWh/RTh", cop: "kW/RT", name: "kWh/RTh" },
  { value: 2, unit: "kWc", load: "kWhc", efficiency: "kWc/kWe", name: "COP or EER (kWc/kWe)" },
  { value: 3, unit: "kWth", load: "kWhth", efficiency: "kWth/kWe" }
]

export const WEATHER_TABS = [
  { key: "DryBulbTemp", value: 1, params: ["maxDry", "avgDry"], proposeID: [1], cooled: [1, 2, 3] },
  { key: "WetBulbTemp", value: 2, params: ["maxWet", "avgWet"], proposeID: [1] },
  { key: "ColdWaterTemp", value: 3, params: ["minWater", "maxWater"], proposeID: [5, 6] },
  { key: "DryBulbTemp", value: 4, params: ["minDry", "avgDry"], proposeID: [5] },
  { key: "MeanCondenserWaterSupplyTemp", value: 5, params: ["maxCWS", "avgCWS"], proposeID: [1], cooled: [1, 3] }
]

export const WEATHER_PARAM_OPTIONS = [
  { key: "MinDryBulbTemp", value: 1, param: "minDry", note: "Peak", period: 1 },
  { key: "MaxDryBulbTemp", value: 2, param: "maxDry", note: "Peak", period: 1 },
  { key: "AvgDryBulbTemp", value: 3, param: "avgDry", note: "OffPeak", period: 2 },
  { key: "MinWetBulbTemp", value: 4, param: "minWet", note: "Peak" },
  { key: "MaxWetBulbTemp", value: 5, param: "maxWet", note: "Peak", period: 1 },
  { key: "AvgWetBulbTemp", value: 6, param: "avgWet", note: "OffPeak", period: 2 },
  { key: "ColdWaterTemp", value: 7, param: "minWater", note: "Peak", period: 1 },
  { key: "ColdWaterTemp", value: 8, param: "maxWater", note: "OffPeak", period: 2 },
  { key: "MeanMaxCWSTemp", value: 9, param: "maxCWS", note: "Peak", period: 1 },
  { key: "MeanAvgCWSTemp", value: 10, param: "avgCWS", note: "OffPeak", period: 2 }
]

export const CURRENCY_NULL = { name: "", value: 0, symbol: "--" }
export const CURRENCY_OPTIONS = [
  { name: "USD", value: 150, symbol: "$", fxRate: 1 },
  { name: "CNY", value: 840, symbol: "￥", fxRate: 7.0078 },
  { name: "EUR", value: 978, symbol: "€", fxRate: 0.8644 },
  { name: "GBP", value: 826, symbol: "£", fxRate: 0.7503 },
  { name: "CAD", value: 124, symbol: "C$", fxRate: 1.3947 },
  { name: "JPY", value: 392, symbol: "Ұ", fxRate: 159.1199 },
  { name: "INR", value: 356, symbol: "₹", fxRate: 90.9089 },
  { name: "SGD", value: 702, symbol: "S$", fxRate: 1.292 },
  { name: "HKD", value: 344, symbol: "HK$", fxRate: 7.7968 },
  { name: "MOP", value: 446, symbol: "MOP$", fxRate: 8.0365 },
  { name: "TWD", value: 901, symbol: "NT$", fxRate: 31.767 },
  { name: "KRW", value: 410, symbol: "₩", fxRate: 1477.8153 },
  { name: "NZD", value: 554, symbol: "NZ$", fxRate: 1.7501 },
  { name: "AED", value: 784, symbol: "د.إ", fxRate: 3.6881 },
  { name: "QAR", value: 634, symbol: "ر.ق", fxRate: 3.6623 },
  { name: "SAR", value: 682, symbol: "ر.س", fxRate: 3.7654 },
  { name: "KWD", value: 414, symbol: "د.ك", fxRate: 0.3075 },
  { name: "MYR", value: 458, symbol: "RM", fxRate: 4.0632 },
  { name: "THB", value: 764, symbol: "฿", fxRate: 31.5525 },
  { name: "VND", value: 704, symbol: "₫", fxRate: 26444.5283 },
  { name: "AUD", value: 36, symbol: "A$", fxRate: 1.4992 }
]

export const BUILD_OPTIONS = [
  { key: "LARGE_OFFICE", value: 1, peak: { hours: 9, boilerUse: 90, waterDemand: 125 }, offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 } },
  { key: "MEDIUM_OFFICE", value: 2, peak: { hours: 9, boilerUse: 90, waterDemand: 125 }, offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 } },
  { key: "SMALL_OFFICE", value: 3, peak: { hours: 9, boilerUse: 90, waterDemand: 125 }, offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 } },
  { key: "MALL", value: 4, peak: { hours: 9, boilerUse: 90, waterDemand: 150 }, offPeak: { hours: 15, boilerUse: 25, waterDemand: 75 } },
  { key: "HOTEL", value: 5, peak: { hours: 8, boilerUse: 90, waterDemand: 450 }, offPeak: { hours: 16, boilerUse: 35, waterDemand: 150 } },
  { key: "HOSPITAL", value: 6, peak: { hours: 14, boilerUse: 90, waterDemand: 650 }, offPeak: { hours: 10, boilerUse: 50, waterDemand: 250 } },
  { key: "RESTAURANT", value: 7, peak: { hours: 8, boilerUse: 90, waterDemand: 450 }, offPeak: { hours: 16, boilerUse: 35, waterDemand: 150 } },
  { key: "SCHOOL", value: 8, peak: { hours: 6, boilerUse: 90, waterDemand: 50 }, offPeak: { hours: 18, boilerUse: 25, waterDemand: 15 } },
  { key: "EDUCATIONAL_INSTITUTIONS", value: 9, peak: { hours: 10, boilerUse: 90, waterDemand: 60 }, offPeak: { hours: 14, boilerUse: 25, waterDemand: 15 } },
  { key: "RESIDENTIAL", value: 10, peak: { hours: 6, boilerUse: 90, waterDemand: 400 }, offPeak: { hours: 18, boilerUse: 30, waterDemand: 200 } },
  { key: "OTHERS", value: 100, peak: { hours: 16, boilerUse: 90, waterDemand: null }, offPeak: { hours: 8, boilerUse: 25, waterDemand: null } }
]

export const APPLY_OPTIONS = [
  { key: "SpaceCooling", value: 1, icon: "icon-cooling", color: "#1891F6" },
  { key: "SpaceHeating", value: 2, icon: "icon-heating", color: "#eb5623" },
  { key: "DomesticHotWater", value: 3, icon: "icon-hotWater", color: "#f18c1e" },
  { key: "SHandDHW", value: 4, icon: "icon-heating", color: "#f18c1e" }
]

export const OBJECTIVE_EQPT_OPTIONS = [
  { value: 1, key: "chiller", spaceApp: [1], proposeID: [1, 2, 3, 4] },
  { value: 2, key: "pump", spaceApp: [1], proposeID: [2, 3] },
  { value: 7, key: "chwp", spaceApp: [1], proposeID: [2], param: "CHWP" },
  { value: 8, key: "cwp", spaceApp: [1], proposeID: [3], param: "CWP" },
  { value: 3, key: "coolingTower", spaceApp: [1], proposeID: [4], param: "CT" },
  { value: 4, key: "dryCooler", spaceApp: [1], proposeID: [2, 3] }, // Currently displayed in Observation of air cooled only  --lix 20251110
  { value: 5, key: "heatPump", proposeID: [5, 6], param: "heat_pump" },
  { value: 6, key: "boiler", proposeID: [5, 6] },
  { value: 9, key: "plant", spaceApp: [1], proposeID: [1, 2, 3, 4] },
  { value: 99, key: "controlSys", spaceApp: [1], proposeID: [1, 2, 3, 4] } // Currently displayed in Observation only   --lix 20251110
  // { value: 100, key: "other", spaceApp: [1, 2, 3], proposeID: [1, 2, 3, 4] }  // canceled --lix 20251110
]

export const COOLED_OPTIONS = [
  { key: "WaterCooled", value: 1 },
  { key: "AirCooled", value: 2 }
]

export const HEAT_SOURCE_OPTIONS = [
  { key: "WaterSource", value: 1 },
  { key: "AirSource", value: 2 }
]

export const COMPRESSOR_OPTIONS = [
  { key: "wcCentri", value: 1, type: "waterCooled", compressor: "centrifugal", comp: 1, src: 1 },
  { key: "wcScrew", value: 2, type: "waterCooled", compressor: "screw", comp: 2, src: 1 },
  { key: "wcRecip", value: 6, type: "waterCooled", compressor: "reciprocating", comp: 4, src: 1 },
  { key: "wcScroll", value: 7, type: "waterCooled", compressor: "scroll", comp: 3, src: 1 },
  { key: "acScrew", value: 3, type: "airCooled", compressor: "screw", comp: 2, src: 2 },
  { key: "acScroll", value: 4, type: "airCooled", compressor: "scroll", comp: 3, src: 2 },
  { key: "acRecip", value: 5, type: "airCooled", compressor: "reciprocating", comp: 4, src: 2 }
]

export const COMPRESSOR_ENUMS = [
  { key: "Centrifugal", value: 1 },
  { key: "Screw", value: 2 },
  { key: "Scroll", value: 3 },
  { key: "Reciprocating", value: 4 },
  { key: "Rotary", value: 5 }
]

export const PUMP_EQPT_OPTIONS = [
  { key: "chwpPrimary", value: 2, note: "PrimaryPump" },
  { key: "chwpSecondary", value: 3, note: "SecondaryPump" },
  { key: "cwp", value: 1 }
]

export const PUMP_TYPE_OPTIONS = [
  { key: "ChilledWaterPrimary", value: 1 },
  { key: "ChilledWaterPrimarySecondary", value: 2 },
  { key: "CondenserWaterSys", value: 3 }
]

export const PUMP_HEADER_OPTIONS = [
  { key: "CommonHeader", value: 1 },
  { key: "Dedicated_1_1", value: 2 }
]

export const DRY_COOLER_EQPT_OPTIONS = [
  { key: "CondenserWater", value: 1 }
  // { key: "ChilledWater", value: 2 }
]

export const DEGRADATION_RATE = [
  { key: "Degradation_25", value: 0.25, note: "GoodCondition" },
  { key: "Degradation_50", value: 0.5, note: "AverageCondition" },
  { key: "Degradation_75", value: 0.75, note: "BelowAverageCondition" },
  { key: "Degradation_100", value: 1, note: "BadCondition" }
]

export const ENERGY_OPTIONS = [
  { key: "GasFuel", value: 1, unit: "m³", cvRate: 52, kgCO2e: 0.202 },
  { key: "LiquidFuel", value: 2, unit: "liters", cvRate: 47, kgCO2e: 0.267 },
  { key: "ElectricalEnergy", value: 3, unit: "kWh", cvRate: 1 }
]

export const DATA_VIEW_OPTIONS = [
  { key: "DataTable", value: 1 },
  { key: "ChartView", value: 2 }
]

export const PERIOD_OFF = [{ key: "Off", value: 0 }]
export const PERIOD_OPTIONS = [
  { key: "Peak", value: 1, param: "peak" },
  { key: "OffPeak", value: 2, param: "offPeak" }
]
export const PERIOD_ALL = [{ key: "AllPeak", value: 3, param: "allPeak" }]

export const WEEK_OPTIONS = [
  { key: "Weekday", value: 1, param: "weekday" },
  { key: "Weekend", value: 2, param: "weekend" },
  { key: "WholeWeek", value: 3, param: "wholeWeek" }
]

export const WEEK_PERIOD_OPTIONS = [
  { key: "WeekdayPeak", value: 1, param: "weekdayPeak", week: 1, peak: 1 },
  { key: "WeekdayOffPeak", value: 2, param: "weekdayOffPeak", week: 1, peak: 2 },
  { key: "WeekendPeak", value: 3, param: "weekendPeak", week: 2, peak: 1 },
  { key: "WeekendOffPeak", value: 4, param: "weekendOffPeak", week: 2, peak: 2 }
]

export const AUTO_MANUAL = [
  { key: "Automatic", value: 1, note: "AlgorithmSelectsConfig" },
  { key: "Reconfigured", value: 2, note: "UserSelectsConfig" }
]

export const CLUSTER_TABS = [
  { key: "ManualCluster", value: 1, component: "Manual" },
  { key: "DigitalECAT", value: 2, component: "ECat" }
]

export const CLUSTER_TYPE = [
  { key: "SingleCluster", value: 1 },
  { key: "MultipleCLuster", value: 2 }
]

export const EQUIP_RETROFIT_STATUS = [
  { key: "New", value: 1 },
  { key: "Existing", value: 2 },
  { key: "Remove", value: 3 }
]

export const POST_OPTION_PARAMS = [
  { key: "RatedCoolingCapacity", value: 1, param: "capacity" },
  { key: "ChillerModel", value: 2, param: "chiller" }
]

export const ESTIMATE_PATHS = [
  { key: "PathA", value: 1 },
  { key: "PathB", value: 2 }
  // { key: "PathC", value: 3 }
]

export const CALCULATE_METHODS = [
  // { key: "Method3", value: 3 }, // disabled by Jeet --20260209 in Teams
  { key: "Method1", value: 1 }
  // { key: "Method2", value: 2 }
]

export const HEATING_PATHS = [
  { key: "HeatingPathA", value: 1 },
  { key: "HeatingPathB", value: 2 }
]

export const PROFILE_STEP_1 = [{ key: "OperatingCalendar" }]

export const COOLING_PATH_A_1_STEPS = [
  { key: "OperatingHours" },
  { key: "ReferChiller" },
  { key: "OperatingLoad" },
  { key: "StepEstimateCoolingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "StepMonthlyCoolingLoad", note: "WeightedAvgCoolingLoad", unit: "CAPACITY_UNIT" },
  { key: "EstimateChillerCount", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyChillerCount" },
  { key: "StepEstimatePower", action: "Estimating", icon: "icon-estimate" },
  { key: "ChillerPower", param: ["hr", "peak", "offPeak"], note: "WeightAvgPower", unit: "kW_UNIT" },
  { key: "AuxiliaryPower", note: "ActualWeightedAveragePower", unit: "kW_UNIT" }
]

export const COOLING_PATH_B_STEPS = [
  { key: "RunningHours", note: "RunningHrsPerDay" },
  { key: "ReferChiller" },
  { key: "EnergyConsumption", note: "ChillerEnergyConsumption", unit: "kWh_UNIT" },
  { key: "StepEstimatePower", action: "Estimating", icon: "icon-estimate" },
  { key: "ChillerPower", note: "WeightAvgPower", unit: "kW_UNIT" },
  { key: "EstimateChillerCount", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyChillerCount" },
  { key: "StepEstimateCoolingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "StepMonthlyCoolingLoad", note: "WeightedAvgCoolingLoad", unit: "CAPACITY_UNIT" },
  { key: "AuxiliaryPower", note: "ActualWeightedAveragePower", unit: "kW_UNIT" }
]

export const HEATING_PATH_A_STEPS = [
  { key: "OperatingCalendar", sbCode: 20611 },
  { key: "RunningHours", note: "RunningHrsPerDay", sbCode: 20612 },
  { key: "BoilerOperation", sbCode: 20613 },
  { key: "EstimateHeatingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyHeatingLoad", note: "AvgHeatingLoad", unit: "CAPACITY_UNIT", sbCode: 20615 },
  { key: "EstimateBoilerCount", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyBoilerCount", note: "MonthlyBoilerCount", sbCode: 20616 },
  { key: "EstimateEnergyConsumption", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyEnergyConsumption", note: "BoilerEnergyConsumption", unit: "ENERGY_UNIT", sbCode: 20617 }
]

export const HEATING_PATH_B_STEPS = [
  { key: "OperatingCalendar", sbCode: 20611 },
  { key: "RunningHours", note: "RunningHrsPerDay", sbCode: 20612 },
  { key: "BoilerOperation", sbCode: 20623 },
  { key: "MonthlyEnergyConsumption", note: "BoilerEnergyConsumption", unit: "ENERGY_UNIT", sbCode: 20627 },
  { key: "EstimateBoilerCount", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyBoilerCount", note: "MonthlyBoilerCount", sbCode: 20626 },
  { key: "EstimateHeatingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "MonthlyHeatingLoad", note: "AvgHeatingLoad", unit: "CAPACITY_UNIT", sbCode: 20625 }
]

export const NAVBAR_MENUS = [{ key: "Objective" }, { key: "Baseline" }, { key: "Proposed" }]

export const OBJECTIVE_MENUS = [{ key: "Objective", path: "/project/objective" }]

export const PRE_STEPS = [
  { key: "Profile", path: "/project/baseline/profile" },
  { key: "ExistingEqptSpecs", path: "/project/baseline/equipment" },
  { key: "SiteObservation", path: "/project/baseline/observation" },
  { key: "BaselineConfig", path: "/project/baseline/baselineCfg" },
  { key: "MonthlyBaseline", path: "/project/baseline/baselineList" },
  { key: "Analysis", action: "Analyzing", icon: "icon-analysis", animation: "rotate" },
  { key: "BaselinePreview", path: "/project/baseline/preview" },
  { key: "GenerateReport", action: "Generating", icon: "icon-ppt", animation: "output", path: "/project/baseline/report", hidden: true }
]

export const POST_STEPS = [
  { key: "SetupOperatingCondition", path: "/project/proposed/condition" },
  { key: "DefineNewEquipment", path: "/project/proposed/equipment" },
  { key: "Analysis", action: "Analyzing", icon: "icon-analysis", animation: "rotate" },
  { key: "RetrofitSolution", path: "/project/proposed/solution" }
]

// 冷机轴承类型
export const BEARING_TYPES = [
  { key: "Standard", value: 1 }, // 标准
  { key: "Ceramic", value: 2 }, // 陶瓷
  { key: "Magnetic", value: 3 } // 磁性
]

// Digital eCAT 区域类型
export const ECAT_REGIONAL_TYPES = [
  { key: "ASIA", value: 1 }, // 亚洲
  { key: "EMEA", value: 2 }, // 中东
  { key: "NAO", value: 3 } // 北美
]

// 定变频
export const FIXED_VARIABLE_TYPES = [
  { key: "VFD", value: 1 },
  { key: "NonVFD", value: 2 }
]

// DO NOT REMOVE "name" attr, used in JsonDataConversion.js
export const ECAT_HEAT_SOURCE_OPTIONS = [
  { key: "WaterSource", value: 1, name: "Water-source" },
  { key: "AirSource", value: 2, name: "Air-source" }
]

export const LIB_OPTIONS = [
  { key: "ECatLib", value: 1 },
  { key: "OwnLib", value: 2 }
]

export const CURVE_OPTIONS = [
  { key: "ConstantEfficiency", value: 1 },
  { key: "UserDefinedCurve", value: 2 }
]

// REFRIGERANT_TYPES
export const REFRIGERANT_TYPES = [
  { key: "R-1234ze(E)", value: "R-1234ze(E)" },
  { key: "R134a", value: "R134a" },
  { key: "R410A", value: "R410A" },
  { key: "R513A", value: "R513A" },
  { key: "R32", value: "R32" },
  { key: "R-1233zd(E)", value: "R-1233zd(E)" }
]

export const OBJECTIVE = [
  { key: "Cooling", value: 1 },
  { key: "Heating", value: 2 }
]

export const DEVICE_TYPE = [
  { key: "Chiller", value: 1 },
  { key: "HeatPump", value: 2 }
]

// wizard below
export const BUILD_OPTIONS_EXTRA = [
  { key: "PROCESS_COOLING", value: 11 },
  { key: "DATA_CENTER", value: 12 }
]

export const WIZARD_STEPS = [
  { key: "MinimumInput", path: "/wizard/minInput" },
  { key: "GenerateDefaults", action: "Calculating", icon: "icon-analysis", animation: "rotate" },
  { key: "ReviewAssumptions", path: "/wizard/reviewAssumptions" },
  { key: "RunQuickCalculation", action: "Calculating", icon: "icon-analysis", animation: "rotate" },
  { key: "ProposedSolution", path: "/wizard/proposedSolution" },
  { key: "GenerateReport", action: "Generating", icon: "icon-ppt", animation: "output", path: "/project/baseline/report", hidden: true }
]

// define project mode: normal(detailed), or wizard(quick)
export const PROJECT_MODE = Object.freeze({
  NORMAL: 1,
  WIZARD: 2,
  UNSET: 0
})

export const REVIEW_SECTIONS = [
  { key: "Profile", value: 1 },
  { key: "Existing equipment", value: 2 },
  { key: "Site observation", value: 3 },
  { key: "Baseline configuration", value: 4 },
  { key: "Monthly baseline", value: 5 },
  // { key: "Proposed equipment", value: 5 },
  { key: "Financial", value: 6 }
  // { key: "Pump configuration", value: 7 }
  // { key: "Operating condition", value: 8 }
]

export const COOLING_APPLICATION_OPTIONS = [
  { key: "ComfortCooling", value: 1, factor: 0.015 },
  { key: "MixedUse", value: 2, factor: 0.01 },
  { key: "ProcessDataCenter", value: 3, factor: 0.005 },
  { key: "Custom", value: 4, factor: 0.015 }
]



// WEBPACK FOOTER //
// ./src/utils/options.js